<div class="ngx-dialog goreact-modal">
	<div class="goreact-modal-header">
		<h4 class="modal-title" translate="{{data.title}}"></h4>
		<button
			class="close-btn"
			type="button"
			[attr.aria-label]="'common_close' | translate"
			(click)="dismiss()"
		>
			<i class="ficon-app-x"></i>
		</button>
	</div>
	<div class="goreact-modal-body">
		<div class="dates-container" [formGroup]="form">
			<mat-form-field appearance="outline">
				<mat-label>{{ 'optional-date-picker_start-date' | translate }}</mat-label>
				<input
					matInput
					[matDatepicker]="startPicker"
					formControlName="start_date"
				/>
				<mat-hint>{{'common_en-date-format' | translate}}</mat-hint>
				<mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
				<mat-datepicker #startPicker></mat-datepicker>
				<mat-error
					*ngIf="form.controls.start_date.hasError('matDatepickerParse')"
					role="alert"
				>
					{{ 'optional-date-picker_invalid-date' | translate }}
				</mat-error>
			</mat-form-field>
			<mat-form-field appearance="outline">
				<mat-label>{{ 'optional-date-picker_end-date' | translate }}</mat-label>
				<input
					matInput
					[matDatepicker]="endPicker"
					formControlName="end_date"
				/>
				<mat-hint>{{'common_en-date-format' | translate}}</mat-hint>
				<mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
				<mat-datepicker #endPicker></mat-datepicker>
				<mat-error
					*ngIf="form.controls.end_date.hasError('matDatepickerParse')"
					role="alert"
				>
					{{ 'optional-date-picker_invalid-date' | translate }}
				</mat-error>
			</mat-form-field>
			<span *ngIf="form.errors?.dateRangeInvalid" class="form-error" role="alert">
				{{ 'course-template_start-after-end' | translate }}
			</span>
		</div>
	</div>
	<div class="goreact-modal-footer">
		<button
			type="button"
			(click)="dismiss()"
			translate="common_cancel"
			class="goreact-btn tertiary-btn cancel-btn"
		></button>
		<button
			type="submit"
			class="goreact-btn primary-btn submit-btn"
			(click)="submit(form)"
			[disabled]="form.invalid"
		>
			{{ data.submitText | translate }}
		</button>
	</div>
</div>
